<template>
  <RouterView />
</template>

<script>
export default {
  data () {
    return {
      breadcrumb: {
        name: 'Opportunities',
        route: { name: 'sales-opportunities' }
      },
      actions: this.$parent.actions
    }
  }
}
</script>
